import { useContext } from 'react'
import { GlobalBannerContext } from '@/context'

export const useGlobalBanner = () => {
  const ctx = useContext(GlobalBannerContext)
  if (!ctx) throw new Error('useGlobalBanner must be used within a GlobalBannerProvider')
  return ctx
}
